module.exports = __webpack_public_path__ + "static/img/1.db1c4e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/1.png
// module id = kKD9
// module chunks = 0